import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  drivers: [],
  isLoading: true,
  isViewModalOpen: false,
  isDeleteModalOpen: false,
  viewSingleDriver: {},
};

export const fetchDrivers = createAsyncThunk("driver/fetchDrivers", () => {
  return axios
    .get("https://629b40cdcf163ceb8d16b9d9.mockapi.io/drivers")
    .then((response) => response.data);
});

const driverSlice = createSlice({
  name: "driver",
  initialState,
  reducers: {
    viewDriver: (state, action) => {
      state.isViewModalOpen = true;
      state.viewSingleDriver = action.payload;
    },
    openDeleteModal: (state, action) => {
      state.isDeleteModalOpen = true;
      state.viewSingleDriver = action.payload;
    },
    closeModal: (state) => {
      state.isViewModalOpen = false;
      state.isDeleteModalOpen = false;
      state.viewSingleDriver = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDrivers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDrivers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.drivers = action.payload;
      state.error = "";
    });
    builder.addCase(fetchDrivers.rejected, (state, action) => {
      state.isLoading = false;
      state.drivers = [];
      state.error = action.error.message;
    });
  },
});

export const { viewDriver, openDeleteModal, closeModal } = driverSlice.actions;
export default driverSlice.reducer;
